import React, { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { useKeyboardInset } from '@common/hooks/useKeyboardInset';

export const BAR_HEIGHT = 80;

const GlobalStyle = createGlobalStyle`
  body {
    padding-bottom: calc(${BAR_HEIGHT}px + var(--keyboard-inset-bottom, 0px));
  }
`;

const BarWrapper = styled.div<{ zIndex?: number }>`
  position: fixed;
  bottom: var(--keyboard-inset-bottom, 0px);
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.5);
  z-index: ${({ zIndex }) => zIndex || 1700};
`;

type StickyBarProps = {
  children?: boolean | JSX.Element | null;
  zIndex?: number;
  id?: string;
};

export const StickyBarWrapper: FC<StickyBarProps> = ({ id, children, zIndex }) => {
  useKeyboardInset();
  return (
    <>
      <GlobalStyle />
      <BarWrapper id={id} zIndex={zIndex}>
        {children}
      </BarWrapper>
    </>
  );
};
